import LutronDesignerClient, {
  MigrateToAthenaRequest,
  OpenArtifactRequest,
} from "./LutronDesignerClient";

export default class LutronDesignerClientProxy {
  public static async openArtifactRequest(
    waitForInstalled: () => Promise<void>,
    payload: OpenArtifactRequest["payload"],
  ) {
    await waitForInstalled();
    LutronDesignerClient.openArtifactRequest(payload);
  }

  public static async createArtifactRequest(
    waitForInstalled: () => Promise<void>,
  ) {
    await waitForInstalled();
    LutronDesignerClient.createArtifactRequest();
  }

  public static async openLocalRequest(waitForInstalled: () => Promise<void>) {
    await waitForInstalled();
    LutronDesignerClient.openLocalRequest();
  }

  public static async migrateToAthenaRequest(
    waitForInstalled: () => Promise<void>,
    payload: MigrateToAthenaRequest["payload"],
  ) {
    await waitForInstalled();
    LutronDesignerClient.migrateToAthenaRequest(payload);
  }
}
